import { render, staticRenderFns } from "./AppSubscribeBar.vue?vue&type=template&id=2bf01d6a&"
import script from "./AppSubscribeBar.vue?vue&type=script&lang=js&"
export * from "./AppSubscribeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports